const routes = [{
        path: '/',
        component: () =>
            import (/* webpackChunkName: "home" */ '../pages/Index'),
        meta: {
            title: 'صفحه اصلی'
        },
        children: [{
                path: '/',
                name: 'home',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/Home'),
                meta: {
                    title: 'صفحه اصلی'
                },
            },
            {
                path: '/product/:id/:slug?',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/ProductDetails'),
                meta: {
                    title: 'محصول'
                },
                name: 'product.detail'
            },
            {
                path: '/UserPayment',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/UserPayment'),
                meta: {
                    title: 'پرداخت کاربر'
                },
                name: 'UserPayment'
            },
            {
                path: '/products',
                name: 'products',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/ProductList'),
                meta: {
                    title: 'لیست محصولات'
                },
            },
            {
                path: '/iran-products',
                name: 'iranProducts',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/iranProducts'),
                meta: {
                    title: 'لیست محصولات ایران'
                },
            },
            {
                path: '/all-categories',
                name: 'allCategories',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/allCategories'),
                meta: {
                    title: 'همه دسته بندی ها'
                },
            },
            {
                path: '/products/category/:category/:slug?',
                name: 'products.category',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/ProductList'),
                meta: {
                    title: 'لیست محصولات'
                },
            },
            {
                path: '/iran-products/category/:category/:slug?',
                name: 'iranProducts.category',
                component: () =>
                    import (/* webpackChunkName: "home" */ '../pages/iranProducts'),
                meta: {
                    title: 'لیست محصولات ایران'
                },
            },
            {
                path: '/cart',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/Cart'),
                meta: {
                    title: 'سبد خرید'
                },
                name: 'cart'
            },
            {
                path: '/user-panel',
                name: 'panel',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/UserPanel'),
                meta: {
                    title: 'پنل کاربری',
                    auth: true
                },
            },


            {
                path: '/order/:id',
                name: 'order',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/order'),
                meta: {
                    title: 'سفارشات',
                    auth: true
                },
            },
            {
                path: '/callback',
                name: 'callback',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/callback'),
                meta: {
                    title: 'در حال هدایت'
                },
            }, ,
            {
                path: '/about-us',
                name: 'about-us',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/AboutUs'),
                meta: {
                    title: 'درباره ما'
                },
            },
            {
                path: '/contact',
                name: 'contact',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/Contact'),
                meta: {
                    title: 'ارتباط با ما'
                },
            },
            {
                path: '/common-questions',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/CommonQuestions'),
                meta: {
                    title: 'پرسش های متداول'
                },
            },
            
            {
                name: 'page',
                path: '/pages/:page/:slug?',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../pages/pages.vue'),
                meta: {
                    title: 'صفحات '
                },
            },
            {
                path: '/payment-method',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../components/Static/PaymentMethod.vue'),
                meta: {
                    title: 'شیوه پرداخت '
                },
            },
            {
                path: '/rules',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../components/Static/Rules.vue'),
                meta: {
                    title: 'قوانین و مقررات'
                },
            },
            {
                path: '/sending-product',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../components/Static/SendingProduct.vue'),
                meta: {
                    title: 'رویه ارسال کالا'
                },
            },
            {
                path: '/branches',
                component: () =>
                    import (/* webpackChunkName: "front" */ '../components/Static/Branches.vue'),
                meta: {
                    title: 'جذب نمایندگی'
                },
            },
            {
                path: '/compare',
                name: 'compare',
                component: () => import('@/parts/Front/pages/Compare')
            },
            {
                path: '/404',
                name: '404',
                component: () => import('@/parts/Front/pages/404')
            }
        ]
    },
    {
        path: '/register',
        name: 'register',
        component: () =>
            import (/* webpackChunkName: "front" */ '../pages/LoginAndRegister'),
        meta: {
            title: 'عضویت'
        },
    },
    { path: '*', beforeEnter: (to, from, next) => { next('/404') } },

]



export default routes
